<template>
  <span class="data-table-label" >
    <div class="wrapper-outer">
      <div class="wrapper-inner">
        <span class="rotated" >
          {{ column.label }}
        </span>
      </div>    
    </div>
  </span>
</template>

<script>
export default {
  props: {
    column: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.wrapper-outer,
.wrapper-inner {
  width: 100%;
  padding: 0;
}
.rotated {
  display: block;    
  word-break: break-word;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/DataTableHeader.vue